export const enum TypeTreeElement {
  TREE_GROUP = 'TREE_GROUP',
  TREE_ITEM = 'TREE_ITEM',
}

export const enum ImportTestTemplateModeView {
  SELECT_FILE = 'SELECT_FILE',
  EDIT_TEMPLATE = 'EDIT_TEMPLATE',
}

export const enum EditDetailTestTemplateView {
  EDIT_EXAM = 'EDIT_EXAM',
  EDIT_QUESTION = 'EDIT_QUESTION',
  EDIT_PATH = 'EDIT_PATH',
  EDIT_SUB_QUESTION = 'EDIT_SUB_QUESTION',
}

export const enum QuestionType {
  GROUPED_QUESTION = 'GROUPED_QUESTION',
  ONE_CHOICE_QUESTION = 'ONE_CHOICE_QUESTION',
  SHORT_QUESTION = 'SHORT_QUESTION',
  YES_NO_QUESTION = 'YES_NO_QUESTION',
  TOPIC_QUESTION = 'TOPIC_QUESTION',
}

export const enum ThinkingLevel {
  KNOWING = 'KNOWING',
  UNDERSTANDING = 'UNDERSTANDING',
  APPLYING = 'APPLYING',
  HIGHLY_APPLYING = 'HIGHLY_APPLYING',
}

export const enum ExamSubjectType {
  MATH = 'MATH',
  PHYSIC_CHEMISTRY_BIOLOGY_GEOGRAPHY = 'PHYSIC_CHEMISTRY_BIOLOGY_GEOGRAPHY',
  HISTORY_EDUCDCATION_AND_LAW = 'HISTORY_EDUCDCATION_AND_LAW',
  LITERATURE = 'LITERATURE',
  ENGLISH = 'ENGLISH',
}

export const enum ModePage {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  ADD = 'ADD',
  IMPORT = 'IMPORT',
}

export const enum ApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
